import { observable, computed, makeObservable } from 'mobx';
import {DomainObject} from 'shared/store';
import {fullName} from 'shared/tools';
import _ from 'lodash';
import User from 'main/stores/users/User';

class Collaborator extends DomainObject {
  id;
  user;
  _destroy;

  _relations = {
    user: User
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      user: observable,
      _destroy: observable,
      clientId: computed,
      name: computed
    });

    this.merge(other);
  }

  get clientId() {
    return _.get(this.user, 'id', '');
  }

  get name() {
    if (!this.user) {
      return '';
    }

    return fullName(this.user);
  }
}

export default Collaborator;
